import { render, staticRenderFns } from "./PolicyViewAction.vue?vue&type=template&id=095798ce"
import script from "./PolicyViewAction.vue?vue&type=script&lang=js"
export * from "./PolicyViewAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports